// Ported from vlookup-dramatic/app/contact-us/page.tsx by scripts/revamp/port-design.js
import React from "react";
import { useSelector } from "react-redux";
import Image from "../../components/image";
import { Mail } from "../../lib/icons";
import { contactPage } from "../../lib/content";
import { usePageMeta } from "../../hooks/use-page-meta";
import { ContactForm } from "./contact-form";

export default function ContactUsPage() {
    usePageMeta({ title: "Contact Us", description: contactPage.description });
    // GET setting (loaded by RevampShell) — the same fields the old page showed
    // under the map: address + support email. Design copy is the fallback.
    const setting = useSelector((s) => s.setting) || {};
    const email = setting.support_email || contactPage.email;
    return (<div className="overflow-x-clip">
      <section className="relative isolate py-12 md:py-16">
        <div aria-hidden className="pointer-events-none absolute -left-40 -top-24 -z-10 size-[420px] rounded-full bg-brand-blue/15 blur-3xl"/>
        <div aria-hidden className="pointer-events-none absolute -right-32 top-40 -z-10 size-[360px] rounded-full bg-brand-blue/15 blur-3xl"/>

        <div className="wrap">
          <h1 className="text-center font-display text-4xl font-semibold tracking-tight text-heading md:text-6xl">
            {contactPage.title}
          </h1>

          <div className="mt-10 rounded-[2rem] bg-card px-6 py-10 shadow-sm ring-1 ring-brand-navy/5 md:px-12 md:py-14">
            <div className="grid items-start gap-10 lg:grid-cols-2 lg:gap-14">
              <div>
                <h2 className="font-display text-3xl font-semibold text-heading md:text-4xl">
                  {contactPage.formTitle}
                </h2>
                <span aria-hidden className="mt-3 block h-0.5 w-40 bg-brand-red"/>
                <p className="mt-4 text-base text-muted-foreground">
                  {contactPage.formSub}
                </p>
                <ContactForm />
              </div>

              <div className="relative min-h-[320px] overflow-hidden rounded-2xl shadow-[0_20px_70px_-20px_rgba(26,58,92,0.25)] lg:min-h-[550px]">
                <Image src={contactPage.image} alt={contactPage.imageAlt} fill sizes="(max-width: 1024px) 100vw, 50vw" className="object-cover"/>
              </div>
            </div>

            {/* Location block removed on client feedback (30 Aug) — email only */}
            <div className="mt-12 grid gap-8 border-t border-brand-navy/10 pt-10 sm:grid-cols-2">
              <InfoBlock icon={<Mail className="size-8" strokeWidth={1.5}/>} label={contactPage.emailLabel} value={email} href={`mailto:${email}`}/>
            </div>
          </div>
        </div>
      </section>
    </div>);
}
/* Local map-pin glyph (lucide "map-pin" path) — not in the generated icon set. */
function InfoBlock({ icon, label, value, href, }) {
    const detail = href ? (<a href={href} className="mt-1 block text-sm text-muted-foreground hover:text-brand-red">
      {value}
    </a>) : (<span className="mt-1 block text-sm text-muted-foreground">{value}</span>);
    return (<div className="flex items-center gap-4">
      <span className="flex size-14 shrink-0 items-center justify-center text-brand-red">
        {icon}
      </span>
      <div>
        <p className="text-lg font-bold text-brand-navy">{label}</p>
        {detail}
      </div>
    </div>);
}
